/**
 * アプリケーション全体に関わるStateを扱うモジュール群
 */
import { combineReducers } from 'redux';

import errorsReducer from './errors';
import fetchReducer from './fetch';
import routerReducer from './router';
import glossariesReducer from './glossaries';
import masterReducer from './master';
import principalReducer from './principal';
import initializeReducer from './initialize';
import boardReducer from './board';
import purchaseReducer from './purchase';
import purchaseSessionReducer from './purchaseSession';
import pageTransitionReducer from './pageTransition';
import completionReducer from './completion';
import userReducer from './user';
import filterReducer from './filter';

const appReducers = combineReducers({
  router: routerReducer,
  fetch: fetchReducer,
  error: errorsReducer,
  glossaries: glossariesReducer,
  master: masterReducer,
  principal: principalReducer,
  initialize: initializeReducer,
  board: boardReducer,
  purchase: purchaseReducer,
  purchaseSession: purchaseSessionReducer,
  pageTransition: pageTransitionReducer,
  completion: completionReducer,
  user: userReducer,
  filter: filterReducer
});

export default appReducers;
